import React, { useCallback, useEffect } from 'react';
import cs from 'classnames';
import { EyeIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers';
import { I18n } from '@fiverr-private/i18n-react';
import { useMonitoring, Providers } from '../../../monitoring';
import { PlusButton } from './PlusButton';

import styles from './AddEmptyBlockFreelancerPage.module.scss';

interface AddEmptyBlockProps extends React.PropsWithChildren<any> {
    className?: string;
    contentWrapperClassName?: string;
    leftContent: React.ReactNode;
    descriptionTitle?: React.ReactNode;
    description: React.ReactNode;
    buttonText: React.ReactNode;
    buttonHref: string;
    mpEvents?: {
        type: string;
        clickType: string;
    };
    isPrivate?: boolean;
}

export const AddEmptyBlock: React.FC<AddEmptyBlockProps> = ({
    className,
    contentWrapperClassName,
    leftContent,
    descriptionTitle,
    description,
    buttonText,
    buttonHref,
    mpEvents,
    isPrivate,
}) => {
    const { fireEvents } = useMonitoring();

    const onAddClick = useCallback(() => {
        if (mpEvents?.clickType) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: mpEvents.clickType,
                },
            });
        }
    }, [mpEvents, fireEvents]);

    useEffect(() => {
        if (mpEvents?.type) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: mpEvents?.type,
                },
            });
        }
    }, [mpEvents, fireEvents]);

    return (
        <div className={cs(styles.container, className, 'flex')}>
            {isPrivate && (
                <div className={styles.private}>
                    <div className="m-r-4 flex">
                        <EyeIcon color={grey_900} />
                    </div>
                    <I18n k="freelancer_page.private" />
                </div>
            )}
            <div className={cs(styles.wrapper, 'flex flex-center')}>
                <div className={cs(contentWrapperClassName, 'flex flex-row p-24')}>
                    {leftContent}
                    <div className={cs('flex flex-col flex-center', { 'm-l-32': !!leftContent })}>
                        {descriptionTitle && (
                            <div className={cs(styles.descriptionTitle, 'co-text-darker text-bold m-b-8')}>
                                {descriptionTitle}
                            </div>
                        )}
                        <div className="co-text-darker m-b-12">{description}</div>
                        <PlusButton className={styles.button} href={buttonHref} onClick={onAddClick}>
                            {buttonText}
                        </PlusButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
